/*
 * Provides string related utlity methods.
 */
export default class String {

    /*
     * Converts a string to kebab case to support a valid HTML id.
     */
    static toKebabCase(value: string) : string {
        return value.replace(/[^A-Za-z0-9 ]/g, ' ').split(' ').filter(x => x).join('-').toLowerCase();
    }

    /*
    * HTML encode the provided text
     */
    static encodeHTMLEntities(text: string) : string {
        var textArea = document.createElement('textarea');
        textArea.innerText = text;
        return textArea.innerHTML;
    }

    /*
     * Converts a string to proper (a.k.a. sentence) case
     */
    static toProperCase(str) {
        return str.toLowerCase().replace(/(?:^|\s)\w/g, function(match) {
            return match.toUpperCase();
        });
    }
    
}